import { useContext } from 'react';
import MobileFormContext from '../../../../components/mobileForm/context/mobileFormContext';

export function useAttachmentsComponent({ idInput, parents }) {
  const { getAttachmentsSignedPost } = useContext(MobileFormContext);

  const uploadAttachment = async (file) => {
    const { fileKey } = await getAttachmentsSignedPost({ file, idInput, parents });
    return { fileKey };
  };

  return { uploadAttachment };
}
